// extracted by mini-css-extract-plugin
export default {"game":"Game_game__Kv0oe","button":"Game_button__WBSHz","padding":"Game_padding__3whPx","loading":"Game_loading__4mNvi"};